import { render, staticRenderFns } from "./BCXFilterTabs.vue?vue&type=template&id=0cc91ae2&scoped=true"
import script from "./BCXFilterTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXFilterTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXFilterTabs.vue?vue&type=style&index=0&id=0cc91ae2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc91ae2",
  null
  
)

export default component.exports